export const payList = [
  'cvv',
  'card_number',
  'card_exp',
  'card_holder',
  'phone_customer',
  'email_customer',
];
